module.exports = "<div class=\"middle-box text-center animated fadeInDown\">\r\n    <h1>500</h1>\r\n    <h3 class=\"font-bold\">Lo sentimos</h3>\r\n\r\n    <div class=\"error-desc\">\r\n        Se ha presentado un inconveniente en nuestros servidores, por favor intentelo más tarde. Agradecemos su comprensión\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/errores/500.template.html
// module id = ../../../../../src/app/components/common/errores/500.template.html
// module chunks = 0